export const vContact = {
  firstName: [{ type: 'present', message: 'first name missing' }],
  lastName: [{ type: 'present', message: 'last name missing' }],
  email: [{ type: 'present', message: 'email missing' }],
}
